import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { CircularProgress } from 'material-ui/Progress';
import Typography from 'material-ui/Typography';
import Button from 'material-ui/Button';
import TextField from 'material-ui/TextField';
import { FormGroup, FormControlLabel } from 'material-ui/Form';
import Checkbox from 'material-ui/Checkbox';
import ContinueButton from '../../common/components/Buttons/ContinueButton';
import colors from '../../../config/themeColors';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
        marginBottom: unit * 2,
        marginTop: unit * 2,
    },
    button: {
        marginLeft: unit * 2,
        '&:first-child': {
            marginLeft: 0,
        },
    },
    buttons: {
        marginTop: unit * 2,
    },
    description: {
        marginLeft: unit * 2,
        marginBottom: unit * 2,
        color: colors.brownishGrey,
    },
    formControl: {
        marginTop: unit * 3,
        minWidth: unit * 26,
        '&:not(:last-of-type)': {
            marginRight: unit * 3,
        },
    },
    checkbox: {
        marginLeft: 0,
    },
});

function Register(props) {
    const emailError = props.user.showMailError && !props.user.isValidMail
        ? 'Incorrect email'
        : null;
    const acceptLabel = 'By creating SGL Fintech Account you accept our Terms of Use and Privacy Policy';
    const emailInUse = (
        props.error && props.errorMail.toLowerCase() === props.user.mail.toLowerCase()
    )
        ? 'Mail already in use'
        : null;
    const register = () => {
        props
            .register({
                ...props.user,
                applicationId: props.applicationId,
            })
            .then((data) => {
                props.setCustomer(data.value);
                props.setStep(3);
                props.setStepCompleted(2, true);
            });
    };
    if (props.isPending) {
        return (
            <div className={props.classes.root}>
                <CircularProgress />
            </div>
        );
    }
    return props.customer.uid
        ? (
            <div className={props.classes.root}>
                <Typography component="p" className={props.classes.description}>
                    You are logged as {props.customer.mail}
                </Typography>
                <div className={props.classes.buttons}>
                    <Button
                        className={props.classes.button}
                        color="default"
                        onClick={() => props.setStep(1)}
                    >
                        Back
                    </Button>
                    <ContinueButton
                        className={props.classes.button}
                        onClick={() => {
                            props.setStep(3);
                            props.setStepCompleted(2, true);
                        }}
                    />
                </div>
            </div>)
        : (
            <div className={props.classes.root}>
                <Typography component="p" className={props.classes.description}>
                    Please register to get a SGL Fintech account and continue with the DiP
                    application process you already have a SGL Fintech account?, sign in here.
                </Typography>
                <div>
                    <TextField
                        className={props.classes.formControl}
                        label="Mail"
                        id="mail"
                        type="email"
                        value={props.user.mail}
                        error={(
                            (props.user.showMailError && !props.user.isValidMail) || !!emailInUse
                        )}
                        onChange={event => props.setUserMail(event)}
                        onBlur={() => props.onBlurMail()}
                        helperText={emailError || emailInUse}
                    />
                    <TextField
                        className={props.classes.formControl}
                        label="Password"
                        id="password"
                        type="password"
                        value={props.user.password}
                        error={props.user.showPasswordError && !props.user.isValidPassword}
                        onChange={event => props.setUserPassword(event)}
                        onBlur={() => props.onBlurPassword()}
                        helperText="Minimum 6 characters"
                    />
                </div>
                <div>
                    <FormGroup>
                        <FormControlLabel
                            className={props.classes.checkbox}
                            control={
                                <Checkbox
                                    checked={props.user.acceptedRules}
                                    onChange={() => {
                                        props.setUserAcceptRules(!props.user.acceptedRules);
                                    }}
                                    value="true"
                                />
                            }
                            label={acceptLabel}
                        />
                    </FormGroup>
                </div>
                <div className={props.classes.buttons}>
                    <Button
                        className={props.classes.button}
                        color="default"
                        onClick={() => props.setStep(1)}
                    >
                        Back
                    </Button>
                    <ContinueButton
                        className={props.classes.button}
                        onClick={() => register()}
                        disabled={(
                            !props.user.isValidMail
                            || !props.user.isValidPassword
                            || !props.user.acceptedRules
                            || !!emailInUse
                        )}
                    >
                        Register &amp; Continue
                    </ContinueButton>
                </div>
            </div>
        );
}

Register.propTypes = {
    user: PropTypes.object.isRequired,
    error: PropTypes.string.isRequired,
    errorMail: PropTypes.string.isRequired,
    isPending: PropTypes.bool.isRequired,
    applicationId: PropTypes.string.isRequired,
    customer: PropTypes.object.isRequired,
    setStep: PropTypes.func.isRequired,
    setStepCompleted: PropTypes.func.isRequired,
    setUserMail: PropTypes.func.isRequired,
    setUserPassword: PropTypes.func.isRequired,
    setUserAcceptRules: PropTypes.func.isRequired,
    onBlurMail: PropTypes.func.isRequired,
    onBlurPassword: PropTypes.func.isRequired,
    register: PropTypes.func.isRequired,
    setCustomer: PropTypes.func.isRequired,
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/app/FormStepper/Register/Register.js